import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-clients',
  templateUrl: './our-clients.component.html',
  styleUrls: ['./our-clients.component.css'],
})
export class OurClientsComponent implements OnInit {
  constructor() {
    console.log('Loading');
  }

  ngOnInit(): void {}
}
